















import { Component, Prop, Vue } from "vue-property-decorator";
import waitComment from "./waitComment/index.vue";
import alreadyComment from "./alreadyComment/index.vue";
import commentInfo from "./commentInfo/index.vue";
@Component({
  components: {
    waitComment,
    alreadyComment,
    commentInfo,
  },
})
export default class extends Vue {
  activeName = "waitComment";
  handleClick(evt: any) {
    this.activeName = evt.name;
  }
  created() {
    if (this.$route.query.from) {
      this.activeName = this.$route.query.from;
    } else {
      this.activeName = "waitComment";
    }
  }
}
